$(() => {
  const $navbarToggler = $('.navbar-toggler')
  const navOffvancas = document.querySelector('#nav-offvancas')
  const $navbar = $('.navbar')

  navOffvancas.addEventListener('show.bs.offcanvas', () => {
    $navbar.addClass('active-offcanvas')
    $navbarToggler.addClass('active')
  })

  navOffvancas.addEventListener('hide.bs.offcanvas', () => {
    $navbar.removeClass('active-offcanvas')
    $navbarToggler.removeClass('active')
  })

  if($navbar.hasClass('is-front-page')) {
    $(window).on('load scroll', () => {
      if(window.scrollY >= window.innerHeight) {
        $navbar.addClass('active')
      }else {
        $navbar.removeClass('active')
      }
    })
  }

  $('.nav-equipment__item').on({
    'mouseenter' : function() {
      if(window.matchMedia('(min-width: 768px').matches) {
        const $this = $(this)
        const $dropdown = $this.find('.mega-dropdown-equipment')

        if($dropdown.length) {
          $dropdown.fadeIn()
        }
      }
    },
    'mouseleave' : function() {
      if(window.matchMedia('(min-width: 768px').matches) {
        const $this = $(this)
        const $dropdown = $this.find('.mega-dropdown-equipment')

        if($dropdown.length) {
          $dropdown.fadeOut()
        }
      }
    },
  })
})